// MTurk completion is NOT a redirect: the worker's HIT is submitted by POSTing
// a form to the Worker site's externalSubmit endpoint. The backend (Ship 1)
// gives us the exact endpoint (submit_to = <turkSubmitTo>/mturk/externalSubmit,
// live or sandbox) and the assignmentId to echo back.
//
// buildMturkForm is the pure, testable part (it just constructs the form);
// submitMturkForm appends it and submits, which navigates the page to MTurk.

export function buildMturkForm(
  submitTo: string,
  assignmentId: string,
): HTMLFormElement {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = submitTo;
  form.style.display = "none";

  const hidden = (name: string, value: string): HTMLInputElement => {
    const el = document.createElement("input");
    el.type = "hidden";
    el.name = name;
    el.value = value;
    return el;
  };

  // assignmentId is required by externalSubmit. We add one extra field because
  // some browsers reject a POST whose body is a single field.
  form.appendChild(hidden("assignmentId", assignmentId));
  form.appendChild(hidden("jolive_completed", "1"));

  return form;
}

export function submitMturkForm(submitTo: string, assignmentId: string): void {
  const form = buildMturkForm(submitTo, assignmentId);
  document.body.appendChild(form);
  form.submit();
}
